// Types
import {
  OrganizationType,
  StoreCareerStatus,
  StoreGender,
} from 'api/graphql-global-types';
import { GetCountryList_getCountryList } from 'api/users/types/GetCountryList';
import { UserRole } from 'api/graphql-global-types';
import {
  GetAllCountriesV2,
  GetAllCountriesV2_getAllCountriesV2,
} from 'api/locations/types/GetAllCountriesV2';

// for case when user removes text from input and submits
export const isEmptyString = (value: string | null): string | null => {
  return value === '' ? null : value;
};

// for case when user removes text from input and submits
export const isZero = (value: number | null): number | null => {
  return value === 0 ? null : value;
};
export const findStateByName = (
  stateName: string,
  data: GetCountryList_getCountryList[]
): GetCountryList_getCountryList | null | undefined => {
  return data.reduce<GetCountryList_getCountryList | null | undefined>(
    (foundState, country) =>
      foundState ||
      (country?.states?.find((state) => state.name === stateName) as
        | GetCountryList_getCountryList
        | undefined),
    null
  );
};
export const findStateByCode = (
  stateCode: string,
  data: GetCountryList_getCountryList[]
): GetCountryList_getCountryList | null | undefined => {
  return data.reduce<GetCountryList_getCountryList | null | undefined>(
    (foundState, country) =>
      foundState ||
      (country?.states?.find((state) => state.code === stateCode) as
        | GetCountryList_getCountryList
        | undefined),
    null
  );
};

export type OrgTypeOption = {
  value: string;
  label: string;
};

export const ORGANIZATION_TYPE_OPTIONS: OrgTypeOption[] = [
  {
    value: OrganizationType.Gym,
    label: 'Gym',
  },
  {
    value: OrganizationType.EventOrganizer,
    label: 'Event/Organizer',
  },
  {
    value: OrganizationType.AssociationLeagueTeam,
    label: 'Association/League/Team',
  },
  {
    value: OrganizationType.Other,
    label: 'Other',
  },
];

export const STORE_ROLES = [
  UserRole.Athlete,
  UserRole.ContentCreator,
  UserRole.Organization,
];

export const CAREER_STATUS_OPTIONS = [
  {
    value: StoreCareerStatus.Active,
    label: 'Active',
  },
  {
    value: StoreCareerStatus.Retired,
    label: 'Retired',
  },
];

// Only Male/Female are selectable on Athlete/Content Creator profiles. The
// StoreGender enum still has legacy values (other/preferNotToSay) that may
// exist on old profiles.
export const PROFILE_GENDER_OPTIONS = [
  {
    value: StoreGender.male,
    label: 'Male',
  },
  {
    value: StoreGender.female,
    label: 'Female',
  },
];

// Legacy values map to undefined so the Select shows the placeholder instead of
// the raw enum, and an untouched field is omitted from the mutation input
// (the stored value is kept).
export const getProfileGenderFormValue = (
  gender?: StoreGender | null
): StoreGender | undefined =>
  PROFILE_GENDER_OPTIONS.find((option) => option.value === gender)?.value;

export const findCountryByIso2 = (
  countries: GetAllCountriesV2,
  country: string
): GetAllCountriesV2_getAllCountriesV2 | null => {
  return (
    countries?.getAllCountriesV2?.find((item) => item.iso2 === country) || null
  );
};
